
<!-- Filter -->
@if (searchFields?.length > 0) {
  <div class="table-filter">
    <div class="d-flex justify-content-center">
      <div class="col-12 col-md-7">
        <mat-form-field class="search-form-field col-12" appearance="outline">
          <input (keyup)="filterTable()" [(ngModel)]="searchKey" autocomplete="off" matInput placeholder="Search" />
          @if (searchKey) {
            <button (click)="onSearchClear()" mat-icon-button matSuffix>
              <mat-icon>close</mat-icon>
            </button>
          }
        </mat-form-field>
      </div>
    </div>
  </div>
}
<!-- end of Filter -->

@if (cacheAdvanceSearchFields?.length > 0) {
  <div class="col-md-12 mb-3">
    <div class="col-md-12 bg-warning-subtle shadow-lg p-3">
      <div class="col-12 position-relative">
        <h6 class="fw-bold mb-0">Advance Search</h6>
        <h6><i>Combined By : {{cacheSearchCombinationType !== null ? cacheSearchCombinationType : SearchCombinationTypeEnum.Or}}</i></h6>
        <button (click)="clearAdvanceSearch()" mat-icon-button color="warn" class="rounded-4 position-absolute top-0 start-100 translate-middle bg-danger-subtle">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      @for (advanceSearchField of cacheAdvanceSearchFields; track advanceSearchField) {
        <div class="col-md-12 px-2 my-2">
          <div class="row detail-information search-info rounded-3">
            <div class="col-md-4">
              <div class="block">
                <h6 class="title">Field Name</h6>
                <h6 class="detail">{{ advanceSearchField?.fieldName }}</h6>
              </div>
            </div>
            <div class="col-md-4">
              <div class="block">
                <h6 class="title">Search Type</h6>
                <h6 class="detail">{{ advanceSearchField?.searchType}}</h6>
              </div>
            </div>
            <div class="col-md-4">
              <div class="block">
                <h6 class="title">Search Value(s)</h6>
                <h6 class="detail">
                  @if (advanceSearchField?.searchType !== SearchOperationType.Between &&
                    advanceSearchField?.searchType !== SearchOperationType.IsNotNull && advanceSearchField?.searchType !== SearchOperationType.IsNull) {
                    {{ advanceSearchField?.fieldValue}}
                  }
                  @if (advanceSearchField?.searchType === SearchOperationType.Between) {
                    {{ advanceSearchField?.fieldValues }}
                  }
                </h6>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}

<div class="col-md-12">
  <div class="table-scroll-wrapper">
  <table (matSortChange)="sortData($event)" id="table" class="table rounded-4 align-middle custom-table mb-0 {{ tableCssClass }}" matSort>
    <thead class="">
      <tr>
        @for (tableColumn of cacheTableColumns; track tableColumn) {
          <!-- if sort exist-->
          @if (tableColumn?.sortableColumn) {
            <th [mat-sort-header]="tableColumn?.sortableColumn" class="{{ tableColumn?.theadCellClass}}">
              {{tableColumn.title }}
            </th>
          } @else {
            <th class="{{ tableColumn?.theadCellClass}}"> {{tableColumn.title }} </th>
          }
          <!-- /if sort exist-->
          <!-- no sort-->
          <!--/ no sort-->
        }
      </tr>
    </thead>
    <tbody class="border-top-0">
      @for (tableData of tableData$ | async; track tableData; let j = $index) {
        <tr class="move-up" style="{{ '--order:' + 0.25 * (1 + j)}}">
          @for (tableColumn of cacheTableColumns; track tableColumn) {
            <td class="{{ tableColumn?.tbodyCellClass}}">
              <span class="d-md-none d-block table-header-sm">{{ tableColumn?.title}}</span>
              <!--index cell-->
              @if (tableColumn.type === tableColumnType.index) {
                {{ j + 1 + currentPage * pageSize | number}}
              }
              <!--/ index cell-->
              <!--checkbox cell-->
              @if (tableColumn.type === tableColumnType.inputCheckbox) {
                <mat-checkbox
                  (change)="$event ? selection.toggle(tableData) : null"
                  (click)="$event.stopPropagation()"
                  [checked]="selection.isSelected(tableData)">
                </mat-checkbox>
              }
              <!--/ checkbox cell-->
              <!-- text or html cell-->
              @if ((tableColumn.type == tableColumnType.text || tableColumn.type == null || tableColumn.type === undefined) && !tableColumn?.isActionColumn) {
                <span [innerHTML]="settingsService.getTableObjectValue(tableData, tableColumn.keyword)"></span>
              }
              <!--/ text or html cell-->
              <!-- url cell-->
              @if (tableColumn.type == tableColumnType.url) {
                <a href="{{settingsService.getTableObjectValue(tableData, tableColumn.keyword)}}" target="_blank"><span [innerHTML]="settingsService.getTableObjectValue(tableData, tableColumn.keyword)"></span></a>
              }
              <!--/ url cell-->
              <!-- img cell-->
              @if (tableColumn.type == tableColumnType.img) {
                @if (settingsService.getTableObjectValue(tableData, tableColumn.keyword)) {
                  <img [src]="'data:image/jpg;base64,' + settingsService.getTableObjectValue(tableData, tableColumn.keyword) | safeResource" alt="img"
                    style="border-radius: 8px; width: 100px">
                  } @else {
                    <mat-icon style="color: #d8dbe0;">face</mat-icon>
                  }
                }
                <!--/ img cell-->
                <!--number cell-->
                @if (tableColumn.type == tableColumnType.number) {
                  @if (settingsService.getTableObjectValue(tableData, tableColumn.keyword) | isNumber) {
                    {{ settingsService.getTableObjectValue(tableData, tableColumn.keyword) | number}}
                  } @else {
                    {{ settingsService.getTableObjectValue(tableData, tableColumn.keyword)}}
                  }
                }
                <!--/ number cell-->
                <!--date cell-->
                @if (tableColumn.type === tableColumnType.date) {
                  @if (settingsService.getTableObjectValue(tableData, tableColumn.keyword) | isDateValid) {
                    {{ settingsService.getTableObjectValue(tableData, tableColumn.keyword) | date : tableColumn.dateFormat}}
                  } @else {
                    {{ settingsService.getTableObjectValue(tableData, tableColumn.keyword) | date}}
                  }
                }
                <!--/ date column-->
                <!--projection cell-->
                @if (tableColumn.type === tableColumnType.projection) {
                  <ng-content select="[{{ tableColumn.keyword}}]"></ng-content>
                }
                <!--/ projection column-->
                <!--action cell-->
                @if (tableColumn?.isActionColumn) {
                  <ng-container [ngTemplateOutletContext]="{data : tableData}" [ngTemplateOutlet]="actions"></ng-container>
                }
                <!--/ action cell-->
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

    @if (cacheTotalElements === 0) {
      <div class="col-12 d-flex justify-content-center fs-6 my-4">
        <small class="move-up --order-3">No Record Found</small>
      </div>
    }

    <app-pagination-buttons (clickedPage)="getPage($event)"
      (selectedPageSize)="getPageSize($event)"
      (onTableColumnSelection)="tableColumnChange($event)"
      (onTableAdvanceSearch)="tableAdvanceSearch($event)"
      (onCopyClicked)="copyTable($event)"
      [currentPage]="currentPage"
      [pageSizeOptions]="pageSizeOptions"
      [pagination]="pagination"
      [tableColumns]="tableColumns"
      [searchFields]="searchFields"
      [cacheAdvanceSearchFields]="cacheAdvanceSearchFields"
      [totalPage]="totalPages"
      [totalElement]="cacheTotalElements">
    </app-pagination-buttons>

  </div>

